const t = "Pressione Enter para editar", e = {
  pressEnterToEdit: t
};
export {
  e as default,
  t as pressEnterToEdit
};
